import { PointerType } from "../interaction/types";

/**
 * How the rulers are moved, depending on what draws:
 * - the finger (normal mode on a touch screen): by their handle only, the bar
 *   stays click-through since a stroke may start on it;
 * - the stylus (stylus mode): the finger no longer draws, it grabs the bar
 *   itself, and the handles are hidden;
 * - the mouse, precise enough to grab the bar in any mode: without a touch
 *   screen, no handles either.
 */
export interface RulerGrabPolicy {
  showHandles: boolean;
  barGrabbedBy: readonly PointerType[];
}

export function rulerGrabPolicy(
  stylusMode: boolean,
  touchScreen: boolean,
): RulerGrabPolicy {
  return {
    showHandles: touchScreen && !stylusMode,
    barGrabbedBy: stylusMode
      ? [PointerType.Mouse, PointerType.Touch]
      : [PointerType.Mouse],
  };
}

export function hasTouchScreen(): boolean {
  return typeof navigator !== "undefined" && navigator.maxTouchPoints > 0;
}
